import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Subject } from 'rxjs';

import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';

import { UsuarioOnline } from '../entities/UsuarioOnline.entity';
import { UsuarioUpdate } from '../entities/usuarioUpdate.entity';
import { Contrato } from './../entities/contrato.entity';
import { ContratosUser } from './../entities/ContratosUser.entity';
import { Respuesta } from '../entities/respuesta.entity';

import { GraficoComponent } from './../home/Components/grafico.component';

@Component({
  selector: 'app-menudesktop',
  templateUrl: './menudesktop.component.html'
})
export class MenudesktopComponent implements OnInit {

  public currentUrl: string;
  public resultado: Respuesta;
  public messageCabecera: string;
  public messageComplet: string;
  public typeException: number;
  @Output() contratoenvio = new EventEmitter();
  public contratos: Contrato[];
  public positionselected: number;
  public efactura: boolean;
  public contratoSeleccionado: Contrato;
  public esPagadorOInactivo: boolean;
  public esFicticio: boolean;
  public static changeContrato: Subject<boolean> = new Subject();

  constructor(private userService: UserService, private sessionService: SessionService) {
    this.sessionService.sessionEvent2.subscribe((esPagadorOInactivo: boolean) => {
      this.esPagadorOInactivo = esPagadorOInactivo;
    });
    MenudesktopComponent.changeContrato.subscribe(res => {
      this.SeleccionarContrato();
    });
  }

  ngOnInit() {
    if (this.sessionService.contratos !== undefined) {
      this.contratos = this.sessionService.contratos;
      this.efactura = this.sessionService.efactura;
      if (this.sessionService.contratoSelected === undefined) {
        this.contratoSeleccionado = this.sessionService.contratoSelected = this.contratos[0];
        this.sessionService.PosicionContratoSelected = 0;
      } else {
        this.positionselected = this.sessionService.PosicionContratoSelected;
      }
      this.esPagadorOInactivo = this.sessionService.esPagadorOInactivo = this.userService.esPagadorOInactivo(this.sessionService.contratoSelected, this.sessionService.login);
      this.esFicticio = this.sessionService.contratoSelected.Ficticio;
    }
  }

  public SeleccionarContrato() {
    this.contratos = this.sessionService.contratos;
    this.efactura = this.sessionService.efactura;
    this.positionselected = this.sessionService.PosicionContratoSelected;
    this.sessionService.PosicionContratoSelected = this.positionselected;
    this.sessionService.contratoSelected = this.contratos[this.positionselected];
    this.esPagadorOInactivo = this.sessionService.esPagadorOInactivo;
    this.esFicticio = this.sessionService.contratoSelected.Ficticio;
    this.CargaFacturasContratoSeleccionado();
  }

  public ContratoSeleccionado(event) {
    this.sessionService.PosicionContratoSelected = this.positionselected;
    this.contratoSeleccionado = this.sessionService.contratoSelected = this.contratos[this.positionselected];
    this.sessionService.esPagadorOInactivo = this.esPagadorOInactivo = this.userService.esPagadorOInactivo(this.contratoSeleccionado, this.sessionService.login);
    this.esFicticio = this.contratoSeleccionado.Ficticio;
    this.CargaFacturasContratoSeleccionado();
  }

  public CargaFacturasContratoSeleccionado() {
    const contratoUsuario = new ContratosUser();
    contratoUsuario.ContratoSeleccionado = this.sessionService.contratoSelected.Codigo;
    if (this.sessionService.contratoSelected.Facturas.length === 0) {
      this.userService.authenicate(contratoUsuario)
        .then(
          response => this.authenicateOnSuccess(response),
          response => this.authenicateOnError(response)
        );
    } else {
      GraficoComponent.UpdateData.next(this.sessionService.contratoSelected.Facturas);
      this.contratoenvio.emit({ contratoSeleccionado: this.sessionService.contratoSelected });
    }
  }

  private authenicateOnSuccess(response: ContratosUser) {
    this.sessionService.contratoSelected.Facturas = response.Contratos[0].Facturas;
    this.sessionService.contratos[this.positionselected].Facturas = response.Contratos[0].Facturas;
    GraficoComponent.UpdateData.next(this.sessionService.contratoSelected.Facturas);
    this.contratoenvio.emit({ contratoSeleccionado: this.sessionService.contratoSelected });
  }

  private authenicateOnError(response) {
  }

  public subscribirFacturaElectronica() {
    const user: UsuarioUpdate = new UsuarioUpdate();
    let usuarioOnline: UsuarioOnline = new UsuarioOnline();
    usuarioOnline = this.sessionService.usuario;
    usuarioOnline.EFactura = true;
    user.UsuarioOnline = usuarioOnline;

    this.userService.updateuser(this.sessionService.explotacion, user)
      .then(
        response => this.updateuserOnSuccess(response),
        response => this.updateuserOnError(response)
      );
  }

  public updateuserOnSuccess(response) {
    this.efactura = true;
    this.sessionService.efactura = true;
    this.closeModal();
  }

  public updateuserOnError(response) {
  }

  // MODAL

  _showModalFacturaSubscribe = false;

  showModal() { return this._showModalFacturaSubscribe; }

  closeModal() { this._showModalFacturaSubscribe = false; }
}
